// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0bea4040","239":"c7f200ea","453":"ac37f842","455":"754c7267"}[chunkId] + ".chunk.js";
};